module.exports = __webpack_public_path__ + "static/media/i0.a129a669.svg";